export enum DnsCheckStatus {
  Ok = "ok",
  Missing = "missing",
  Misconfigured = "misconfigured",
  BlockedByConflict = "blocked_by_conflict",
  Error = "error",
}
